import React from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";

import { createStructuredSelector } from "reselect";
import { selectCurrentUser } from "../../redux/user/user.selector";
import { selectGemeinde } from "../../redux/gemeinde/gemeinde.selector";
import ReportEditContainer from "../../components/report/report-edit.container";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import {
  setCurrentReport,
  setCurrentReportById,
} from "../../redux/reports/report.actions";

const ReportEditPage = ({
  currentUser,
  gemeinde,
  setCurrentReportById,
  setCurrentReport,
}) => {
  // PATH-Property entspricht der ID des Reports
  //PATH-Property "new"  neuer Report
  let { berichtId } = useParams();

  if (berichtId !== "new") {
    setCurrentReportById(berichtId);
  } else {
    setCurrentReport({
      titel: "",
      frage1: "",
      frage2: "",
      frage3: "",
      frage4: "",
      frage5: "",
      frage6: "",
      kontakt: "",
      autor: currentUser ? currentUser.displayName : "",
      bild1: null,
      bild2: null,
      oeffentlich: false,
      gemeindeId: gemeinde ? gemeinde.id : "",
    });
  }
  return (
    <div>
      <PageHeaderComponent title="Projektbericht" />
      <ReportEditContainer />
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  setCurrentReportById: (id) => dispatch(setCurrentReportById(id)),
  setCurrentReport: (report) => dispatch(setCurrentReport(report)),
});
const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  gemeinde: selectGemeinde,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportEditPage);
